import { MultiTabGrid } from '@components/_SiteWide/Layout/MultiTabGrid'
import { DwellSiteGrid } from '@components/DriverTracking/Dwell/components/DwellSiteGrid/DwellSiteGrid'
import { DwellTerminalGrid } from '@components/DriverTracking/Dwell/components/DwellTerminalGrid/DwellTerminalGrid'
import React from 'react'

export function DwellPage() {
  const tabs = [
    {
      defaultActive: true,
      title: 'Terminals',
      description: 'Manage terminal dwell times.',
      component: <DwellTerminalGrid />,
    },
    {
      title: 'Sites',
      description: 'Manage site dwell times.',
      component: <DwellSiteGrid />,
    },
  ]
  const multiGridConfig = {
    tabs,
    stickStorageKey: 'dwell-page-tab',
  }

  return <MultiTabGrid {...multiGridConfig} />
}
